<div class="a-select-multiple"
  [class.gray-bg]="grayBg"
  [class.is-optional]="isOptional">

  <div class="a-select-multiple__optional" *ngIf="isOptional">Optional</div>

  <div class="a-select-multiple__inner" [class.has-error]="control.invalid && isSubmitted">
    <div class="a-select-multiple__items-bg" *ngIf="allItems && allItems.length && showItems" (click)="showDropdown(false)"></div>
    <div class="a-select-multiple__items" @slideInOut
      *ngIf="allItems && allItems.length && showItems" 
      [class.open-top]="openPositionTop">
      <div class="a-select-multiple__items-inner is-scroll" #scrolledEl>
        <div class="a-select-multiple__item"
          *ngFor="let item of shadowItems; let i = index;" 
          [id]="'a-select-item-id-' + i"
          [class.active]="selectedItems.length ? selectedItems.includes(item[valueKey]) : ''"
          (click)="selectItem(item);">
          {{ item[valueKey] }}
        </div>
        <div class="a-select-multiple__no-found" *ngIf="!shadowItems.length">
          Nothing found
        </div>
      </div>
    </div>

    <div class="a-select-multiple__input-box">
      <input #selectEl
        placeholder=" "
        type="text"
        [ngModel]="searchValue" 
        (ngModelChange)="findResult($event)"
        (focus)="onFocus(true)" 
        (blur)="onFocus(false)">
      <label>{{ label }}</label>
      <i class="app-ico-mask app-ico-mask__select-arrow-down" 
        [class.is-open]="showItems"
        (click)="showDropdown(showItems ? false : true)">
      </i>
    </div>
  </div>

  <div class="a-select-multiple__error-text" @opacityInOut
    *ngIf="control.invalid && isSubmitted && errorMessage">
    {{ errorMessage | translate }}
  </div>

  <div class="a-select-multiple__selected" *ngIf="!disableSelectedList">
    <div class="a-select-multiple__selected__item" *ngFor="let item of selectedItems">
      {{ item }} <i class="app-ico-mask app-ico-mask__x" (click)="removeSelected(item)"></i>
    </div>
  </div>
</div>